var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24043 6.74726L7.24042 6.74727C6.97177 6.99318 6.54466 6.99317 6.27601 6.74729L6.27598 6.74726L0.956408 1.87709L0.956394 1.87708C0.675091 1.6195 0.675112 1.19205 0.956381 0.934466L0.956422 0.934428C1.22506 0.688523 1.65221 0.688523 1.92084 0.934428L1.92086 0.934441L6.75821 5.36312L11.5956 0.934441L11.5987 0.931535L11.5988 0.931563C11.8651 0.696014 12.2795 0.696029 12.5459 0.931547L7.24043 6.74726ZM7.24043 6.74726L12.56 1.87709L12.56 1.87712M7.24043 6.74726L12.56 1.87712M12.56 1.87712L12.5632 1.87413M12.56 1.87712L12.5632 1.87413M12.5632 1.87413C12.8404 1.61138 12.8313 1.18393 12.5459 0.931551L12.5632 1.87413Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.6e1976c0.svg";
export { ForwardRef as ReactComponent };